import MyProviders from "./MyProviders";

const customProvidersModule = {
  __init__: ["myProviders"],
  myProviders: ["type", MyProviders],
};

export default customProvidersModule;
